exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#avatar-col{\n  width:10rem\n}\n#page-user-view table td{\n  vertical-align:top;\n  min-width:140px;\n  padding-bottom:.8rem;\n  word-break:break-all\n}\n@media screen and (max-width: 370px){\n#page-user-view table:not(.permissions-table) td{\n    display:block\n}\n}\n@media screen and (min-width: 1201px)and (max-width: 1211px),only screen and (min-width: 636px)and (max-width: 991px){\n#account-info-col-1{\n    width:calc(100% - 12rem) !important\n}\n}", ""]);

// exports
